export const COOKIE_KEYS = {
  userToken: 'user_token'
} as const
